jQuery(function ($) {
  console.log("Super Cycle Arc ready");

  // FUNC: CREATE CANVAS HALF CIRCLE
  function createHemisphereCanvas(canvasId, animationFunction) {
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext("2d");
    const numRows = 11;
    const dotsPerRowArray = [35, 39, 43, 47, 51, 55, 59, 67, 71, 75, 79];
    const radiusStep = 12;
    const baseRadius = 120;
    const arcOffsetX = canvas.width / 2;
    const arcOffsetY = canvas.height - 20;
    const initialColor = "#9A98D0";
    let targetColor = "#F38336";
    const rows = [];
    let isAnimated = false;

    const stickyParent = $($("#" + canvasId).data("parent"));
    const idx = stickyParent.data("idx");

    // Create dots in arc positions with the initial color
    for (let row = 0; row < numRows; row++) {
      const dotsPerRow = dotsPerRowArray[row];
      const rowDots = [];
      for (let col = 0; col < dotsPerRow; col++) {
        const angle = Math.PI - (col / dotsPerRow) * Math.PI;
        const radius = baseRadius + row * radiusStep;
        const x = radius * Math.cos(angle) + arcOffsetX;
        const y = -radius * Math.sin(angle) + arcOffsetY;
        rowDots.push({ x, y, color: initialColor });
      }
      rows.push(rowDots);
    }

    // Draw dots on the canvas
    function drawDots() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      rows.flat().forEach((dot) => {
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, 3, 0, Math.PI * 2);
        ctx.fillStyle = dot.color;
        ctx.fill();
        ctx.closePath();
      });
    }

    let pc = 0;
    let completed = false;

    function animateDots() {
      const target = stickyParent.data("target");
      const topPosition = stickyParent[0].getBoundingClientRect().top * -1;
      const pH =
        idx === 1
          ? stickyParent.children().first().height()
          : stickyParent.height();
      const vH = $(window).height();
      const full = pH - vH;

      pc = Math.ceil((topPosition / full) * 100);

      const pcCutOff = idx === 1 ? 85 : 70;

      // NOTE: When pc reached pcCutOff, animation is complete
      if (pc >= pcCutOff) {
        pc = pcCutOff;
      }

      pc = Math.ceil((pc / pcCutOff) * 100);

      let progress = Math.ceil((pc / 100) * target);

      if (progress > 100) {
        progress = 100;
      }

      if (pc > 0 && pc <= 100 && !completed) {
        // console.log(idx + " animating " + target + ', ' + progress);

        if (pc >= 100) {
          completed = true;
          console.log(idx + " completed");
          stickyParent.addClass("fade-out");

          $(".fadeInThis").addClass("fadeIn");

          if (idx === 1) {
            // setTimeout(() => {
              progress = 27;
              $(".changeText").fadeOut(200, function () {
                $(this).text("Post-election").fadeIn(300);
              });
            // }, 1000);
          }

          if (idx === 2) {
            // setTimeout(() => {
              progress = 30;
              $(".changeText2").fadeOut(200, function () {
                $(this).text("With quota").fadeIn(300);
              });
            // }, 1000);
          }
        }

        rows.forEach((rowDots) => {
          const oneQuarterLength = Math.ceil(rowDots.length * (progress / 100));
          rowDots.forEach((dot, index) => {
            dot.color = index < oneQuarterLength ? targetColor : initialColor;
          });
          drawDots(); // Redraw the dots after updating colors
        });
      }
    }

    // Trigger animation when canvas is in view
    function isInView() {
      const rect = canvas.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    }

    window.addEventListener("scroll", () => {
      animateDots();
    });

    // Initial draw
    drawDots();
  }

  createHemisphereCanvas("hemisphereCanvasPre", "animateOneQuarterDots");
  createHemisphereCanvas("hemisphereCanvasPost", "animateThreeQuarterDots");
  // END CANVAS HALF CIRCLE
});
